module.exports = __webpack_public_path__ + "static/media/organisation.74b57f86.svg";